import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';

export type SCUIDropzoneProps = {
    onChange: (files: File[]) => void;
    accept?: string | string[];
    multiple?: boolean;
    disabled?: boolean;
    title?: string;
    className?: string;
};

function SCUIDropzone({
    onChange,
    accept,
    multiple = true,
    disabled = false,
    title,
    className,
}: Readonly<SCUIDropzoneProps>) {
    const { t } = useTranslation();

    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                onChange(acceptedFiles);
            }
        },
        [onChange],
    );

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept,
        multiple,
        disabled,
    });

    return (
        <div
            {...getRootProps({ className })}
            style={{
                border: `2px dashed ${isDragActive ? '#0288d1' : '#007bff'}`,
                padding: '20px',
                textAlign: 'center',
                backgroundColor: isDragActive ? 'rgba(2, 136, 209, 0.08)' : undefined,
                opacity: disabled ? 0.45 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer',
                borderRadius: 8,
            }}
        >
            <input {...getInputProps()} />
            {title ? <p style={{ margin: '0 0 8px', fontWeight: 600 }}>{title}</p> : null}
            {isDragActive ? <p>{t('general.dragToUpload')}</p> : <p>{t('general.clickToUpload')}</p>}
        </div>
    );
}

export default SCUIDropzone;
